<script>
    import { sendAnalytics } from "@/core/SendAnalytics";
    import BaseButton from "@main/packages/BaseButton";
    import BaseInput from "@main/packages/BaseInput";

    export default {
        name: "SubscribeForm",
        components: { BaseInput, BaseButton },
        data() {
            return {
                email: "",
                errorSubmit: "",
                successSubmit: false,
                isSubmitted: false,
            };
        },
        methods: {
            sendForm() {
                if (this.isSubmitted) {
                    return;
                }

                if (this.email.length < 1) {
                    this.errorSubmit = "Поле обязательно для заполнения";
                    return;
                }

                this.isSubmitted = true;
                this.errorSubmit = "";

                this.$store.formApi.subscribeTo({ email: this.email }).then((res) => {
                    if (res.error) {
                        this.errorSubmit = "Неверный email";
                    } else {
                        this.successSubmit = true;
                        sendAnalytics.send(sendAnalytics.events.subscribe);
                    }
                });

                setTimeout(() => {
                    this.isSubmitted = false;
                }, 1200);
            },
        },
    };
</script>

<template>
    <form class="form-subscribe" @submit.prevent="sendForm" novalidate>
        <div v-show="!successSubmit" class="form-subscribe__field">
            <base-input
                type="email"
                v-model="email"
                placeholder="Электронная почта"
                :error-text="errorSubmit"
            ></base-input>
        </div>

        <base-button
            variant="v1"
            size="lg"
            class="form-subscribe__button"
            :class="{ 'is-hidden': successSubmit }"
        >
            Подписаться
        </base-button>

        <div v-show="successSubmit" class="form-subscribe__success">Подписка оформлена!</div>
    </form>
</template>

<style lang="scss">
    .form-subscribe {
        position: relative;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        .base-input__field {
            border-radius: 100px;
            background-color: #fff;
            @include bp($bp-desktop-sm) {
                padding-top: 8px;
                padding-bottom: 8px;
            }
        }
    }

    .form-subscribe__field {
        flex-grow: 1;
        .base-input__error {
            position: absolute;
            left: 0;
            bottom: -18px;
        }
    }

    .form-subscribe__button {
        margin-top: 12px;
        margin-left: 0;
        width: 100%;
        &.is-hidden {
            opacity: 0;
            pointer-events: none;
            visibility: hidden;
        }

        @include bp($bp-desktop-sm) {
            margin-top: 0;
            margin-left: -40px;
            width: auto;
            min-width: 220px;
        }
    }

    .form-subscribe__success {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 50%;
        width: 100%;
        max-width: 280px;
        height: 50px;
        font-size: 17px;
        font-weight: 600;
        line-height: 24px;
        color: #fff;
        border-radius: var(--btn-border-radius);
        background-color: var(--btn-accent-color--v1_selected);
        z-index: 1;
        transform: translateX(-50%);
    }
</style>
